package org.gymly.ui.admin

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import coil3.compose.AsyncImage
import org.gymly.model.PickedImagePayload
import org.gymly.theme.AdminColors
import org.gymly.ui.components.PhotoActionBar
import org.gymly.util.imagePreviewModel

@Composable
fun ClientPhotoField(
    firstName: String,
    lastName: String,
    pendingPhoto: PickedImagePayload?,
    existingPhotoBytes: ByteArray?,
    pendingFileName: String?,
    removePhoto: Boolean,
    enabled: Boolean,
    compact: Boolean = false,
    onPickPhoto: () -> Unit,
    onCaptureFromTerminal: (() -> Unit)? = null,
    onClearPhoto: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val previewBytes = when {
        removePhoto -> null
        pendingPhoto != null -> pendingPhoto.bytes
        else -> existingPhotoBytes
    }
    val hasPhoto = previewBytes != null && previewBytes.isNotEmpty()
    val previewModel = imagePreviewModel(previewBytes)
    val initials = "${firstName.firstOrNull() ?: '?'}${lastName.firstOrNull() ?: ""}".uppercase()

    Column(modifier) {
        if (!compact) {
            Text(
                "Foto para acceso (rostro)",
                fontSize = 13.sp,
                fontWeight = FontWeight.SemiBold,
                color = AdminColors.Text,
            )
            Text(
                "Usa los iconos para subir un archivo o capturar en el terminal Hikvision.",
                color = AdminColors.TextMuted,
                fontSize = 12.sp,
                modifier = Modifier.padding(top = 4.dp, bottom = 10.dp),
            )
        }
        Row(verticalAlignment = Alignment.CenterVertically) {
            Box(
                Modifier
                    .size(if (compact) 44.dp else 88.dp)
                    .clip(CircleShape)
                    .background(AdminColors.Outline.copy(alpha = 0.25f))
                    .border(1.dp, AdminColors.Outline.copy(alpha = 0.45f), CircleShape),
                contentAlignment = Alignment.Center,
            ) {
                if (previewModel != null) {
                    key(previewModel.takeLast(32)) {
                        AsyncImage(
                            model = previewModel,
                            contentDescription = "Foto",
                            modifier = Modifier.fillMaxSize(),
                            contentScale = ContentScale.Crop,
                        )
                    }
                } else {
                    Text(
                        initials,
                        fontWeight = FontWeight.Bold,
                        fontSize = if (compact) 14.sp else 28.sp,
                        color = AdminColors.Primary,
                    )
                }
            }
            Spacer(Modifier.width(12.dp))
            Column {
                PhotoActionBar(
                    hasPhoto = hasPhoto,
                    enabled = enabled,
                    onUpload = onPickPhoto,
                    onCapture = onCaptureFromTerminal,
                    onRemove = if (hasPhoto) onClearPhoto else null,
                    compact = compact,
                    accent = AdminColors.Primary,
                    error = AdminColors.Error,
                )
                if (!pendingFileName.isNullOrBlank()) {
                    Text(
                        pendingFileName,
                        color = AdminColors.Primary,
                        fontSize = 12.sp,
                        modifier = Modifier.padding(top = 4.dp),
                    )
                }
            }
        }
    }
}

@Composable
fun ClientPhotoSavingOverlay(visible: Boolean) {
    if (!visible) return
    Box(
        Modifier
            .fillMaxSize()
            .background(Color.Black.copy(alpha = 0.08f)),
        contentAlignment = Alignment.Center,
    ) {
        CircularProgressIndicator(color = AdminColors.Primary)
    }
}
